import React from "react";
import { v4 as uuidv4 } from "uuid";

import Landing from "./Landing";

import actionHeaderActions from "../../flux/actions/ActionHeaderActions";
import userActions from "../../flux/actions/UserActions";
import userListStore from "../../flux/stores/user/ListStore";

import { IUserViewData, defaultUserData } from "../../models/user/UserViewData";
import { ISidebarDetail, SidebarDetail } from "../../models/shared/SidebarDetail";
import { UserFormData } from "../../models/user/UserFormData";
import * as CONSTANTS from "../../utilities/Constants";

import { IActionHeaderEditData } from "../../models/shared/ActionHeaderData";
import NoDataOnboarding from "../shared/NoDataOnboarding";
import History from "../../utilities/History";
import loadingActions from "../../flux/actions/LoadingActions";
import userByIdStore from "../../flux/stores/user/ByIdStore";
import userDeleteStore from "../../flux/stores/user/DeleteStore";
import Sidebar from "../sharedNew/sidebarCommon/sidebar";
import SidebarCollapse from "../sharedNew/sidebar/SidebarCollapse";
import SidebarList from "../sharedNew/sidebarCommon/sidebarList";

import auth from "../../utilities/Auth";
import { Spinner } from "@abb/abb-common-ux-react";

interface IIndexState {
  activeId: string;
  searchValue: string;
  activeItem: any;
  listData: ISidebarDetail[];
  isFullSidebarVisible: boolean;
  collapseSidebar: boolean;
  loadLandingPage: boolean;
  userListData: any;
  disableDeleteUser: boolean;
  isLoading: boolean;
}

export default class User extends React.Component<{ location: any }, IIndexState> {
  private _mount = false;
  private reloadFirst = false;
  private id = "";
  private _isSelectedLink = false;
  private _searchId = "";
  private _moduleName = CONSTANTS.MODULE_USERS;
  private _page: number = 1;
  private _hasMore: boolean = false;
  private filteredArray:any = [];

  constructor(props: { location: any }) {
    super(props);
    const searchName = this.props.location &&  this.props.location.state && this.props.location.state.searchName  ? this.props.location.state.searchName : '';
    this._mount = false;
    this.reloadFirst = false;
    this.id = "";

    this.state = {
      collapseSidebar: false,
      activeId: "",
      searchValue: searchName || "",
      activeItem: {},
      listData: [],
      isFullSidebarVisible: true,
      loadLandingPage: false,
      userListData: defaultUserData,
      disableDeleteUser: false,
      isLoading: false
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    History.replace({ state: {} })
    this._mount = true;
    this.reloadFirst = true;
    this.id = ""

    if (this.props.location.state  && this.props.location.state.isReloadFirst !== undefined) {
      this.reloadFirst = this.props.location.state.isReloadFirst;
      this.id = this.props.location.state.id;
    }

    if (
      this.props.location.state &&
      this.props.location.state.isSelectedLink !== undefined
    ) {
      this._isSelectedLink = this.props.location.state.isSelectedLink;
      this._searchId = this.props.location.state.id;
    }

    userListStore.on('change', (state) => {
      this.setState({userListData: state.userDataList})
      const data = state.userDataList as IUserViewData[];
      const items: ISidebarDetail[] = [];
      data.forEach(element => {
        items.push(new SidebarDetail(element.id, element.displayName));
      });

      this.setState({ listData: items },
        () => {
          if (this.reloadFirst) {
            this.triggerGetById(items[0].id)
          } else {
            this.triggerGetById(this.id)
          }
          if(this.state.searchValue){
            this.onsearch(this.state.searchValue);
          }
        }
      );
    });

    userByIdStore.on('change', (state) => {
      this.setState({
        activeItem: state.userData,
        activeId: state.userData.id
      });
    });

    userDeleteStore.on('change', (state) => {
      if (this._mount) {
        this.reloadFirst = state.reload
        History.push(CONSTANTS.USER_INDEX_URL);
        userActions.getAll().then();
      }
    })
    
    this.setState({isLoading: true});
    userActions.getAll().then(() => {
      this.setState({isLoading: false});
    }).catch((error) => {
      console.error(error);
      this.setState({isLoading: false});
    });
  }

  private triggerGetById(id: string) {
    userActions.getById(id).then(() => {
      const receivedData = this.state.activeItem;
      this.setState({ activeId: id, loadLandingPage: true });
      const editData = new UserFormData(true, uuidv4(), id, false, receivedData.firstName, receivedData.lastName, receivedData.email, receivedData.role, receivedData.username, receivedData.password);

      const data: IActionHeaderEditData = {
        moduleName: this._moduleName,
        editData,
        deleteTitle: `${receivedData.firstName} ${receivedData.lastName}`,
        deleteId: id,
        deleteRequestId: uuidv4(),
        deleteMessage: `${receivedData.firstName} ${receivedData.lastName}`
      };

      actionHeaderActions.edit(data).then();

      if(auth.getUserId() === id){
        this.setState({disableDeleteUser: true})
      } else{
        this.setState({disableDeleteUser: false})
      }
    });
  }

  public onSelectLink = (id: string) => {
    this.setState({ activeId: id });
    this.triggerGetById(id);
  }

  public onsearch = (value: any) => {
    this.setState({searchValue: value},
      () => this.applyNameFilter());
  }

  public applyNameFilter = () => {
    this.filteredArray = this.state.userListData.filter((x:any) => {
      const a = this.state.searchValue.toLowerCase();
      const b = x.displayName.toLowerCase();
      return !a || b.includes(a)
    })
    const items: ISidebarDetail[] = [];
      this.filteredArray.forEach((element:any) => {
        items.push(new SidebarDetail(element.id, element.displayName));
      });

      this.setState({ listData: items },
        () => {
          if(items.length !== 0){
            if (this.reloadFirst) {
              if(this._isSelectedLink){
                this.triggerGetById(this._searchId);
              }else{
                this.triggerGetById(items[0].id);
              }
            } else {
              if(this._isSelectedLink){
                this.triggerGetById(this._searchId);
              }else{
                this.triggerGetById(this.id);
              }
            }
          }
        }
      );
  }

  public onCreateClick = () => {
    const createData = new UserFormData(false, uuidv4(), CONSTANTS.DefaultGuid, false, "", "", "", {id:"", name:"", composite:false, clientRole:false, containerId:""}, "", "");
    History.push(CONSTANTS.USER_CREATE_URL, createData);
  }

  public onCollapseSidebar = () => {
    this.setState({
      collapseSidebar: !this.state.collapseSidebar
    })
  }

  public fetchMore = () => {
    this._page = this._page + 1;
  }


  public viewAll() {
    History.push(CONSTANTS.USER_VIEW_ALL);
  }


  public render() {
    return (
      <div className="layout-margin">
        {this.state.isLoading ? (<div style={{ display: "flex", alignItems: "center", justifyContent: "center", textAlign: 'center', height: "90vh" }}><Spinner color="grey" sizeClass="medium" /></div>) : 
        (<>{(this.state.listData.length === 0 && this.state.searchValue.length === 0) ?
          <NoDataOnboarding moduleName={CONSTANTS.MODULE_USERS} onCreateClick={this.onCreateClick} authKey={CONSTANTS.AUTHKEY_USERS} /> :
          <React.Fragment>
          {
            !this.state.collapseSidebar ?
              <div>
                <Sidebar
                authKey={CONSTANTS.AUTHKEY_USERS}
                  onCollapseSidebar={this.onCollapseSidebar}
                  searchValue={this.state.searchValue}
                  onSearch={this.onsearch}
                  onCreateClick={this.onCreateClick}
                  viewAll={this.viewAll}
                  showCloneIcon={false}
                >
                  <SidebarList
                    onSelectLink={this.onSelectLink}
                    listData={this.state.listData}
                    activeId={this.state.activeId}
                    fetchMore={this.fetchMore}
                    hasMore={this._hasMore}
                    module={CONSTANTS.MODULE_USERS}
                  >
                  </SidebarList>
                </Sidebar>
              </div>
              :
              <SidebarCollapse 
              authKey={CONSTANTS.AUTHKEY_USERS}
              onCollapseSidebar={this.onCollapseSidebar} 
              onCreateClick={this.onCreateClick}
              viewAll={this.viewAll}
              showCloneIcon={false}
              ></SidebarCollapse>
          }
          {(this.state.activeId && this.state.activeItem) && <div className={!this.state.collapseSidebar ? "main-layout ml-3 no-padding" : "main-full-layout float-right"}>
            <Landing userData={this.state.activeItem} activeId={this.state.activeId} disableDeleteUser={this.state.disableDeleteUser} />
          </div>}
        </React.Fragment>
        }</>)}
      </div>
    );
  }
}
